import React from 'react';
import GenericNoticeModalUI from '@cube3/ui/src/modals/GenericNoticeModalUI';

export const MobileProfilePictureModal = (props) => {
  const { modalContext } = props;
  const { onClose } = modalContext;
  return (
    <GenericNoticeModalUI
      title={`Notice`}
      text={`Editing your profile picture is currently only possible on desktop.`}
      renderTwoButtons={false}
      buttonText="Close"
      secondButtonColorVariant="filled1"
      onClose={onClose}
    />
  );
};
